import { useCompanyCustomers } from '$src/lib/hooks/useCompanyCustomers'
import { Center, Loader } from '@mantine/core'
import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { useAuthStore } from '../store/useAuthStore'
import { WelcomeLogin } from '../modules/auth/WelcomeLogin'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

function IndexPage() {
  const { isAuthenticated } = useAuthStore()
  const { redirect } = useSearch({ from: '/' })

  if (!isAuthenticated) return <WelcomeLogin />
  // Honor an explicit redirect (e.g. from a magic-link or an auth bounce)
  if (redirect) return <Navigate to={redirect} />
  return <AuthenticatedLanding />
}

// Pick a landing page from the user's access: a user whose only customers are businesses
// (company / housing company) starts in the company portal instead of the empty resident
// home. Everyone else (household, mixed, or no customers) lands on /home.
function AuthenticatedLanding() {
  const { customers, companies, isLoading } = useCompanyCustomers()

  if (isLoading) {
    return (
      <Center h="100dvh">
        <Loader size="md" />
      </Center>
    )
  }

  const hasHousehold = customers.length > companies.length
  const target =
    companies.length > 0 && !hasHousehold ? '/company-portal' : '/home'

  return <Navigate to={target} />
}

export const Route = createFileRoute('/')({
  validateSearch: searchSchema,
  component: IndexPage,
})
